import { FC } from "react";
import { Image } from "react-datocms";
import classNames from "classnames";

import { ImageRecord, ResponsiveImage } from "@graphql/types/graphql";
import s from "./ImageBlock.module.scss";

interface Props {
  data: ImageRecord & {image: {
    responsiveImageFullWidth?: ResponsiveImage;
    responsizeImage?: ResponsiveImage;
  }};
  isSmall?: boolean;
  fullWidth?: boolean;
  isFullHeight?: boolean;
  hasReducedMobileHeight?: boolean;
}

export const ImageBlock: FC<Props> = ({
  data,
  isSmall = false,
  fullWidth = data.fullWidth,
  isFullHeight = false,
  hasReducedMobileHeight = false,
}) => {
  const imageData = fullWidth
    ? (data.image?.responsiveImageFullWidth || data.image?.responsiveImage)
    : data.image?.responsiveImage;

  return (
    <div
      className={classNames(s.ImageBlock, {
        [s.IsSmall]: isSmall,
        [s.isFullWidth]: fullWidth,
        [s.IsFullHeight]: isFullHeight,
        [s.HasReducedMobileHeight]: hasReducedMobileHeight,
      })}
    >
      {imageData && (
        <Image data={imageData} layout="responsive" className={s.Image} />
      )}
      {imageData?.title && (
        <small className={s.Caption}>{imageData.title}</small>
      )}
    </div>
  );
};
